export default function renderArrayOf(source: string) {
  return `(${source})[]`
}
